import { parsePaging } from '../utils';
import { toItem } from '../mappers/item';
export function parseMultiSearchItems(response, settings, thumbnailSizes, folderId) {
  const keys = Object.keys(response.data);
  const data = keys.reduce((prev, categoryId) => [...prev, ...response.data[categoryId].items.map(item => ({
    ...toItem(item, settings, thumbnailSizes),
    categoryId
  }))], []);
  let paging = {
    cursor: null,
    size: null
  };
  if (response.data[folderId]) {
    paging = parsePaging(response.data[folderId]);
  }
  return {
    data,
    paging
  };
}